import { c as _c } from "react/compiler-runtime";
import { USER_ACCOUNT_SETTINGS_FILTERS_API } from 'modules/profile/account-settings/api/account-settings-api';
import { AccountSettingsTimezonesApiInterface } from 'modules/profile/account-settings/types/account-settings-interface';
import useUser from 'shared/hooks/use-user';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
export function useAccountSettingsTimezones() {
  const $ = _c(4);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== user) {
    t0 = () => {
      if (user) {
        return USER_ACCOUNT_SETTINGS_FILTERS_API;
      }
      return null;
    };
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data
  } = useSWR(t0, baseFetcher);
  let t1;
  if ($[2] !== data) {
    t1 = {
      data
    };
    $[2] = data;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}